import { useCheckout } from "@stripe/react-stripe-js/checkout";
import { useCallback, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { CreditCardForm } from "./CreditCardForm";
import { User } from "../../types";
import Lottie from "lottie-react";
import { LoadingDots } from "../../LandingPage";
import loadingdots from "../../lottiedata/loadingdots.json";
import * as amplitude from '@amplitude/analytics-browser';
import { StripeExpressCheckoutElementConfirmEvent } from "@stripe/stripe-js";

  const PayWithCardButton = styled.button`
  width: 100%;
  background: #0b6dff;
  color: white;
  border: 2px solid #e9ecef;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 16px;

  &:hover {
    background:rgb(40, 126, 255);
  }

  &:focus {
    outline: none;
    border-color: #0B6DFF;
    box-shadow: 0 0 0 2px rgba(11, 109, 255, 0.1);
  }
`;

export const CheckoutForm = ({ user, isNoTrialVariation = true }: { user: User; isNoTrialVariation?: boolean }) => {
  const checkout = useCheckout();
  const [showCardForm, setShowCardForm] = useState(false);
  const [showLoadingSpinner, setShowLoadingSpinner] = useState(true);
  const isCheckoutMounted = useRef(false);

  useEffect(() => {
    console.log("checkout.type", checkout.type);
    console.log("checkout", checkout);
    if (checkout.type === "success" && !isCheckoutMounted.current) {
      isCheckoutMounted.current = true;

      checkout.checkout.updateEmail(user.email);
      const ece = checkout.checkout.createExpressCheckoutElement();
      ece.on("confirm", handleExpressConfirm);
      ece.mount("#express-checkout-element");
      ece.on("ready", () => {
        setShowLoadingSpinner(false);
      });
      ece.on("loaderror", (event: any) => {
        setShowLoadingSpinner(false);
        console.error("Express Checkout failed:", event.error.message);
      });
      setTimeout(() => {
        setShowLoadingSpinner(false);
      }, 5000);
    }
  }, [checkout, user]);

  const handlePayWithCard = useCallback(() => {
    setShowCardForm(true);
    amplitude.track("PayWithCardClicked");
  }, []);

  // Handle Express Checkout (Apple Pay, Google Pay, etc.)
  const handleExpressConfirm = async (
      event: StripeExpressCheckoutElementConfirmEvent
  ) => {
      try {
          if (checkout.type === "success") {
              await checkout.checkout.confirm({
                  expressCheckoutConfirmEvent: event,
              });
          }
      } catch (err) {
          console.error("Error during express checkout confirmation:", err);
      }
  };

  return (
    <>
     <div style={{ display: showLoadingSpinner ? "block" : "none" }}>
        <LoadingDots>
          <Lottie autoplay animationData={loadingdots} />
        </LoadingDots> 
      </div>
      <div style={{ display: showLoadingSpinner ? "none" : "block" }}>
        <div id="express-checkout-element" />
        <div>
          {!showCardForm ? (
            <PayWithCardButton onClick={handlePayWithCard}>
              Continue with Card
            </PayWithCardButton>
          ) : (
            <CreditCardForm isNoTrialVariation={isNoTrialVariation} />
          )}
        </div>
      </div>
    </>
  );
}
